import React, { Component } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import DateTimeRangeContainer from "react-advanced-datetimerange-picker";
 
class ProfileDateBlock extends Component {
    constructor(props) {
        super(props);
        // Initialise from parent-supplied range when provided, so the displayed
        // range matches what the parent actually queries; else default to 1 month.
        let start = props.start
            ? moment(props.start)
            : moment(new Date()).subtract(1, "month").startOf('day');

        let end = props.end ? moment(props.end) : moment(new Date()).startOf('day');
        this.state = {
            start: start,
            end: end
        };

        this.onClick = this.onClick.bind(this);
        this.applyCallback = this.applyCallback.bind(this);
    }

    applyCallback(startDate, endDate) {
        this.setState({
            start: startDate,
            end: endDate
        });
        this.props.applyCallback(startDate, endDate);
    }

    rangeCallback(index, value) {
        // console.log(index, value);
    }

    onClick() {
        let newStart = moment(this.state.start).subtract(3, "days");
        // console.log("On Click Callback");
        // console.log(newStart.format("DD-MM-YYYY HH:mm"));
        this.setState({ start: newStart });
    }

    renderGridPickerNoMobileMode(ranges, local, maxDate) {
        let disabled = false;
        let value = `${this.state.start.format(
            "DD-MM-YYYY"
        )} - ${this.state.end.format("DD-MM-YYYY")}`;

        // leftMode opens the calendar toward the left edge. Callers near the left
        // of the page want that; callers elsewhere pass leftMode={false} so the
        // popup drops below/right of the field instead of flying off-screen.
        const leftMode = this.props.leftMode !== undefined ? this.props.leftMode : true;

        return (

            <Form.Group className="customDaterange mb-0" id="DateTimeRangeContainerNoMobileMode" style={{ width: 230, position: "relative" }}>
                <DateTimeRangeContainer
                    ranges={ranges}
                    start={this.state.start}
                    end={this.state.end}
                    local={local}
                    applyCallback={this.applyCallback}
                    smartMode
                    maxDate={maxDate}
                    noMobileMode
                    leftMode={leftMode}
                >
                    <i className="far fa-calendar-day" />
                    <Form.Control
                        className="form-control-custom"
                        id="formControlsTextB"
                        type="text"
                        label="Text"
                        placeholder="Enter text"
                        style={{ cursor: "pointer" }}
                        disabled={disabled}
                        value={value}
                    //onChange={this.props.datefunction}
                    />
                </DateTimeRangeContainer>
            </Form.Group>
        );
    }

    render() {
        let now = new Date();
        let start = moment(
            new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
        );
        let end = moment(start)
            .add(1, "days")
            .subtract(1, "seconds");
        let ranges = {
            "Today Only": [moment(start), moment(start)],
            "Yesterday Only": [
                moment(start).subtract(1, "days"),
                moment(start).subtract(1, "days")
            ],
            "3 Days": [moment(start).subtract(3, "days"), moment(start)],
            "5 Days": [moment(start).subtract(5, "days"), moment(start)],
            "1 Week": [moment(start).subtract(7, "days"), moment(start)],
            "2 Weeks": [moment(start).subtract(14, "days"), moment(start)],
            "1 Month": [moment(start).subtract(1, "months"), moment(start)],
            "1 Year": [moment(start).subtract(1, "years"), moment(start)]
        };
        let local = {
            format: "DD-MM-YYYY",
            sundayFirst: false
        };
        let maxDate = moment(start - 10).add(24, "hour");
        return (
            <React.Fragment>
                {this.renderGridPickerNoMobileMode(ranges, local, maxDate)}
            </React.Fragment>
        );
    }
}
export default ProfileDateBlock;


 